import React from 'react'
import {Routes,Route} from 'react-router-dom';
import Dashboard from './Dashboard';

const DashboardView= (props:any) => {
  const userHasChangePassword = props.data;
  const setUserHasChangePassword = props.onChange;
  return (
     <Routes>
       <Route path="*" element={<Dashboard data={userHasChangePassword} onChange={setUserHasChangePassword}/>} />
     </Routes>
  )
}

export default DashboardView

export {default as NavBar} from './NavBar';
export {default as OldApplicants} from './OldApplicants/OldApplicants';
export {default as Overview} from './Overview2';
// export {default as Overview} from './Overview';
export {default as Applicants} from './Applicants/Applicants';
export {default as Settings} from './Settings/Settings';
export {default as Approvals} from './Approvals/Approve/Approvals';
export {default as Payment} from './Payment/Payment';
export {default as UploadOffLine} from './UploadOffLine/UploadOffLinePayment';
export {default as SideBar} from './SideBar';
export {default as Applications} from './Applications/Applications';
export {default as Interview} from './Interview/Interview';
export { default as TrainingInvites} from './TrainingInvites/TrainingInvites';
export { default as InductionInvites} from './InductionInvites/InductionInvites';
export { default as Reports} from './Reports/Reports';